export const GIFT_HISTORY = {
  heading: 'Reissuance History',
  no_results_text: 'There is no data to show for this customer.',
  subtitle: 'History of offers sent to the customer.',
};
